import React from 'react';
import { useSessionUser } from '../../../../data/hooks/sessionHooks';
import Icon from '../../icons/Icon';
import Link from '../../Link';

const ChatIcon = (props) => {
    const { selected } = props,
        user = useSessionUser();

    if (!user) return null;

    return (
        <Link href={'/chats'} key="chat">
            <Icon icon="event-chat" selected={selected}></Icon>
        </Link>
    );
};

export default ChatIcon;
